import { gql } from "@apollo/client";

//to get the all the board names
export const GET_ALL_TASK_MANAGEMENT_BOARD = gql`
  query GetAllTaskManagementBoard {
    GetAllTaskManagementBoard {
      _id
      Unique_Id
      Company_Code
      Branch_Code
      Board_Name
      createdAt
      updatedAt
    }
  }
`;

// create the new board
export const CREATE_TASK_MANAGEMENT_BOARD = gql`
  mutation CreateTaskManagementBoard($createInput: TaskManagementBoardInput) {
    createTaskManagementBoard(createInput: $createInput) {
      _id
      Unique_Id
      Company_Code
      Branch_Code
      Board_Name
    }
  }
`;

//get board by id

export const GET_BOARD_BY_ID = gql`
  query TaskManagementBoardByID($id: ID) {
    TaskManagementBoardByID(ID: $id) {
      _id
      Unique_Id
      Company_Code
      Branch_Code
      Board_Name
      Columns {
        _id
        Title
        Is_Collapsed
        Serial_No
        Unique_Id
      }
      createdAt
      updatedAt
    }
  }
`;

//Add Column to booard
export const ADD_COLUMN_TO_BOARD = gql`
  mutation AddColumntoBoard($addColumntoBoardId: ID, $userInput: ColumnInput) {
    AddColumntoBoard(id: $addColumntoBoardId, userInput: $userInput) {
      _id
      Title
      Is_Collapsed
      Serial_No
      Unique_Id
    }
  }
`;
//edit column postion by serialno
export const EDIT_TASK_MANAGEMENT_BOARD_SERIAL_NO = gql`
  mutation EditTaskManagementBoard($editTaskManagementBoardId: ID, $userInput: [ColumnInput]) {
    editTaskManagementBoard(id: $editTaskManagementBoardId, userInput: $userInput) {
      _id
      Unique_Id
      Company_Code
      Branch_Code
      Board_Name
      Columns {
        _id
        Serial_No
      }
      createdAt
      updatedAt
    }
  }
`;

//edit column Name

export const EDIT_TASK_MANAGEMENT_COlUMN_NAME = gql`
  mutation EditColumnInBoard($editColumnInBoardId: ID, $userInput: ColumnInput) {
    EditColumnInBoard(id: $editColumnInBoardId, userInput: $userInput) {
      Columns {
        _id
        Title
        Is_Collapsed
        Serial_No
        Unique_Id
      }
      Unique_Id
      Company_Code
      Branch_Code
      Board_Name
      createdAt
      updatedAt
    }
  }
`;

//edit column expand(is_collapsed);

export const EDIT_COLUMN_IS_COLLAPSED = gql`
  mutation EditColumnCollapsed($editColumnCollapsedId: ID, $userInput: ColumnInput) {
    EditColumnCollapsed(id: $editColumnCollapsedId, userInput: $userInput) {
      Columns {
        _id
        Title
        Is_Collapsed
        Serial_No
        Unique_Id
      }
      Unique_Id
      Company_Code
      Branch_Code
      Board_Name
      createdAt
      updatedAt
    }
  }
`;

//create a Task To Paritcular column and board
export const CREATE_TASK_TO_BOARD = gql`
  mutation CreateTaskmanagement($createInput: TaskManagementInput) {
    createTaskmanagement(createInput: $createInput) {
      _id
      Board_ID
      Column_ID
      Title
      Serial_No
      createdAt
      updatedAt
    }
  }
`;

// To get the all the task details

export const GET_ALL_TASKS = gql`
  query GetAllTaskManagementTasks($userInput: TaskmanagementSearch) {
    GetAllTaskManagementTasks(userInput: $userInput) {
      _id
      tasks {
        _id
        Unique_Id
        Board_ID
        Column_ID
        Title
        Serial_No
        Assignee {
          UserName
          Full_Name
        }
        Priority
        Labels
        Start_Date
        Due_Date
        Description
        Attached_Files
        Task_Code
        createdAt
        updatedAt
      }
    }
  }
`;

//Task Name Edit
export const TASK_NAME_EDIT = gql`
  mutation EditTaskManagement($id: ID!, $userInput: TaskManagementInput) {
    editTaskManagement(_id: $id, userInput: $userInput) {
      _id
      Unique_Id
      Board_ID
      Column_ID
      Title
      Serial_No
    }
  }
`;

export const Edit_Task_Position = gql`
  mutation EditTaskManagement($id: ID!, $userInput: TaskManagementInput) {
    editTaskManagement(_id: $id, userInput: $userInput) {
      _id
    }
  }
`;

export const DeleteColumInTaskmanagement = gql`
  mutation DeleteColumInTaskmanagement($boardId: ID, $deleteColumnId: ID, $newColumnId: ID) {
    DeleteColumInTaskmanagement(boardId: $boardId, deleteColumnId: $deleteColumnId, newColumnId: $newColumnId) {
      message
    }
  }
`;

export const GetTaskDetailsByID = gql`
  query GetTaskDetailsByID($taskId: ID!) {
    GetTaskDetailsByID(taskID: $taskId) {
      _id
      Unique_Id
      Board_ID
      Column_ID
      Title
      Serial_No
      Assignee {
        _id
        Unique_Id
        Department
        Mobile
        Email
        Full_Name
        UserName
        Role
        Is_Active
        View_Only_Self_Entry
        View_Only_Current_Year
        Allow_Audit
        Merge_Balance
        createdAt
        updatedAt
      }
      Reporter {
        _id
        Unique_Id
        Department
        Mobile
        Email
        Full_Name
        UserName
        Role
        Is_Active
        View_Only_Self_Entry
        View_Only_Current_Year
        Allow_Audit
        Merge_Balance
        createdAt
        updatedAt
      }
      Priority
      Task_Code
      Labels
      Start_Date
      Due_Date
      Description
      Attached_Files
      History {
        Changed_By
        Changed_At
        Field_Name
        Previous_Data
        New_Data
      }
      createdAt
      updatedAt
    }
  }
`;

export const Edit_Task_details = gql`
  mutation EditTaskManagement($id: ID!, $userInput: TaskManagementInput) {
    editTaskManagement(_id: $id, userInput: $userInput) {
      _id
    }
  }
`;
export const users_query = gql`
  query Getallusers {
    getallusers {
      _id
      Full_Name
    }
  }
`;
export const users_query_search = gql`
  query Getallusers {
    getallusers {
      _id
      Full_Name
    }
  }
`;

export const Add_Files_To_Task = gql`
  mutation AddFilesToTask($addFilesToTaskId: ID!, $file: String!) {
    AddFilesToTask(id: $addFilesToTaskId, file: $file) {
      message
    }
  }
`;
export const Delete_Fiels_To_Task = gql`
  mutation DeleteFileFromTask($TaskID: ID!, $file: String!) {
    DeleteFileFromTask(id: $TaskID, file: $file) {
      message
    }
  }
`;
export const Delete_Board_mutation = gql`
  mutation DeleteTaskManagementBoard($boardId: ID!) {
    deleteTaskManagementBoard(boardId: $boardId) {
      message
    }
  }
`;

export const DeleteTaskCard = gql`
  mutation DeleteTaskCard($deleteTaskCardId: ID!, $pageId: ID!) {
    DeleteTaskCard(id: $deleteTaskCardId, pageId: $pageId) {
      message
    }
  }
`;


export const EditBoardName =gql`
  mutation EditatskBoardName($boardId: ID!, $userInput: BoardDetails) {
    EditatskBoardName(boardId: $boardId, userInput: $userInput) {
      _id
      Board_Name
    }
  }
`